(function () {
  'use strict';

  if (window.__cwWishlistLocalInit) return;
  window.__cwWishlistLocalInit = true;

  var config = window.CartWishlistConfig || {};
  var storageKey =
  'archetype_wishlist_variants_v1';

var state = {
  activeView: 'cart',
  items: readItems(),
  productCache: Object.create(null),
  rendering: false,
  renderQueued: false,
  observerTimer: 0,
  toastTimer: 0
};

  function readItems() {
    try {
      var value = JSON.parse(
        window.localStorage.getItem(storageKey) || '[]'
      );

      if (!Array.isArray(value)) return [];

      return value
        .filter(function (item) {
          return item && item.handle && item.variantId;
        })
        .map(function (item) {
          return {
            handle: String(item.handle),
            variantId: String(item.variantId)
          };
        });
    } catch (error) {
      console.warn(
        '[cart-wishlist] Could not read wishlist storage.',
        error
      );

      return [];
    }
  }

function writeItems(reason) {
  var snapshot = state.items.map(function (item) {
    return {
      handle: item.handle,
      variantId: item.variantId
    };
  });

  try {
    window.localStorage.setItem(
      storageKey,
      JSON.stringify(snapshot)
    );
  } catch (error) {
    console.warn(
      '[cart-wishlist] Could not save wishlist storage.',
      error
    );

    return;
  }

  /*
   * Notify the wishlist page only after the current
   * add/remove/undo operation has finished updating
   * the shared drawer and wishlist icons.
   */
  var notify = function () {
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          reason: reason || 'change',
          items: snapshot
        }
      })
    );
  };

  if (typeof window.queueMicrotask === 'function') {
    window.queueMicrotask(notify);
  } else {
    Promise.resolve().then(notify);
  }
}

  function rootUrl() {
    var root =
      config.routesRoot ||
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) ||
      '/';

    return root.endsWith('/')
      ? root
      : root + '/';
  }

  function productUrl(handle) {
    return (
      rootUrl() +
      'products/' +
      encodeURIComponent(handle || '')
    );
  }

  function wishlistPageUrl() {
    return (
      config.wishlistUrl ||
      rootUrl() + 'pages/wishlist'
    );
  }

  function goToWishlistPage() {
    window.location.assign(
      wishlistPageUrl()
    );
  }

  function numericId(value) {
    return String(value || '')
      .split('/')
      .pop()
      .split('?')[0];
  }

  function money(cents) {
    var value =
      Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency:
            config.currency || 'USD',
          maximumFractionDigits:
            value % 1 === 0 ? 0 : 2
        }
      ).format(value);
    } catch (error) {
      return (
        '$' +
        value.toFixed(
          value % 1 === 0 ? 0 : 2
        )
      );
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(
        /[&<>'"]/g,
        function (character) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#039;',
            '"': '&quot;'
          }[character];
        }
      );
  }

  function eventClosest(event, selector) {
  var path =
    typeof event.composedPath === 'function'
      ? event.composedPath()
      : [];

  for (
    var index = 0;
    index < path.length;
    index += 1
  ) {
    var node = path[index];

    if (
      node instanceof Element &&
      node.matches(selector)
    ) {
      return node;
    }
  }

  var target =
    event.target instanceof Element
      ? event.target
      : event.target &&
        event.target.parentElement;

  return target
    ? target.closest(selector)
    : null;
}

function getVariantOptions(variant) {
  if (
    variant &&
    Array.isArray(variant.options)
  ) {
    return variant.options;
  }

  return [
    variant && variant.option1,
    variant && variant.option2,
    variant && variant.option3
  ].filter(Boolean);
}

function variantChoiceLabel(
  variant,
  colorIndex
) {
  var values =
    getVariantOptions(variant)
      .filter(function (
        value,
        index
      ) {
        return (
          index !== colorIndex &&
          value &&
          value !== 'Default Title'
        );
      });

  if (values.length) {
    return values.join(' - ');
  }

  var fallback =
    String(
      (
        variant &&
        variant.title
      ) ||
      ''
    )
      .replace(
        /\s*\/\s*/g,
        ' - '
      )
      .trim();

  return (
    fallback &&
    fallback !== 'Default Title'
  )
    ? fallback
    : 'Option';
}

function ensureWishlistToast() {
  var toast =
    document.getElementById(
      'cw-wishlist-toast'
    );

  if (toast) return toast;

  toast =
    document.createElement('div');

  toast.id =
    'cw-wishlist-toast';

  toast.className =
    'cw-wishlist-toast';

  toast.setAttribute(
    'role',
    'status'
  );

  toast.setAttribute(
    'aria-live',
    'polite'
  );

  toast.setAttribute(
    'aria-atomic',
    'true'
  );

  toast.innerHTML =
    '<span class="cw-wishlist-toast__message" data-cw-toast-message></span>' +
    '<button type="button" class="cw-wishlist-toast__action" data-cw-toast-action hidden></button>';

  document.body.appendChild(
    toast
  );

  return toast;
}

function hideWishlistToast() {
  var toast =
    document.getElementById(
      'cw-wishlist-toast'
    );

  if (!toast) return;

  toast.classList.remove(
    'is-visible'
  );

  window.clearTimeout(
    state.toastTimer
  );
}

function showWishlistToast(
  message,
  actionLabel,
  actionCallback
) {
  var toast =
    ensureWishlistToast();

  var messageNode =
    toast.querySelector(
      '[data-cw-toast-message]'
    );

  var actionButton =
    toast.querySelector(
      '[data-cw-toast-action]'
    );

  if (messageNode) {
    messageNode.textContent =
      message;
  }

  if (actionButton) {
    actionButton.onclick = null;

    if (
      actionLabel &&
      typeof actionCallback ===
        'function'
    ) {
      actionButton.hidden = false;
      actionButton.textContent =
        actionLabel;

      actionButton.onclick =
        function () {
          hideWishlistToast();
          actionCallback();
        };
    } else {
      actionButton.hidden = true;
      actionButton.textContent = '';
    }
  }

  window.clearTimeout(
    state.toastTimer
  );

  toast.classList.remove(
    'is-visible'
  );

  window.requestAnimationFrame(
    function () {
      toast.classList.add(
        'is-visible'
      );
    }
  );

  state.toastTimer =
    window.setTimeout(
      hideWishlistToast,
      4500
    );
}

  function getDrawer() {
    return document.getElementById(
      'cart-drawer'
    );
  }

  function findItem(handle) {
    return (
      state.items.find(
        function (item) {
          return item.handle === handle;
        }
      ) || null
    );
  }

  function setDrawerScrollLock(open) {
    document.documentElement.classList.toggle(
      'cw-cart-wishlist-open',
      Boolean(open)
    );
  }

  function activate(view) {
    state.activeView =
      view === 'wishlist'
        ? 'wishlist'
        : 'cart';

    var drawer = getDrawer();

    if (!drawer) return;

    drawer
      .querySelectorAll(
        '[data-cw-view]'
      )
      .forEach(function (panel) {
        panel.classList.toggle(
          'is-active',
          panel.getAttribute(
            'data-cw-view'
          ) === state.activeView
        );
      });

    drawer
      .querySelectorAll(
        '[data-cw-tab]'
      )
      .forEach(function (tab) {
        var active =
          tab.getAttribute(
            'data-cw-tab'
          ) === state.activeView;

        tab.classList.toggle(
          'is-active',
          active
        );

        tab.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

        tab.setAttribute(
          'tabindex',
          active ? '0' : '-1'
        );
      });

    var title =
      drawer.querySelector(
        '[data-cw-title]'
      );

    if (title) {
      title.textContent =
        state.activeView === 'wishlist'
          ? 'WISHLIST'
          : 'YOUR BAG';
    }

    if (
      state.activeView ===
      'wishlist'
    ) {
      renderWishlist();
    }
  }

  function openDrawer(view) {
    activate(view || 'cart');

    var drawer = getDrawer();

    if (!drawer) return;

    if (
      typeof drawer.open ===
      'function'
    ) {
      drawer.open();
    } else {
      drawer.setAttribute(
        'open',
        ''
      );

      var panel =
        drawer.querySelector(
          'dialog'
        );

      if (
        panel &&
        !panel.open
      ) {
        panel.setAttribute(
          'open',
          ''
        );
      }
    }

    setDrawerScrollLock(true);
  }

  function closeDrawer() {
    var drawer = getDrawer();

    if (!drawer) return;

    if (
      typeof drawer.close ===
      'function'
    ) {
      drawer.close();
    } else {
      drawer.removeAttribute(
        'open'
      );
    }

    setDrawerScrollLock(false);
  }

  function getSelectedVariantId(
    button
  ) {
    if (!button) return '';

    var direct =
      button.getAttribute(
        'data-variant-id'
      ) ||
      button.getAttribute(
        'data-product-variant-id'
      );

    if (direct) {
      return numericId(direct);
    }

    var form =
      button.closest(
        'form[action*="/cart/add"]'
      );

    if (!form) {
      var component =
        button.closest(
          'product-form-component'
        );

      form =
        component
          ? component.querySelector(
              'form[action*="/cart/add"]'
            )
          : null;
    }

    var formInput =
      form
        ? form.querySelector(
            '[name="id"]'
          )
        : null;

    if (
      formInput &&
      formInput.value
    ) {
      return numericId(
        formInput.value
      );
    }

    var scope =
      button.closest(
        [
          '[data-product-handle]',
          '[data-product-id]',
          '.product-card',
          '.product-info'
        ].join(', ')
      );

    var input =
      scope
        ? scope.querySelector(
            [
              '[name="id"]:checked',
              'select[name="id"]',
              'input[name="id"]'
            ].join(', ')
          )
        : null;

    return numericId(
      input && input.value
        ? input.value
        : ''
    );
  }

  function fetchProduct(handle) {
    if (
      state.productCache[handle]
    ) {
      return Promise.resolve(
        state.productCache[handle]
      );
    }

    return fetch(
      productUrl(handle) + '.js',
      {
        credentials:
          'same-origin'
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not load ' +
            handle +
            '.'
          );
        }

        return response.json();
      })
      .then(function (product) {
        state.productCache[handle] =
          product;

        return product;
      });
  }

  function firstAvailableVariant(
    product
  ) {
    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {
      return null;
    }

    return (
      product.variants.find(
        function (variant) {
          return (
            variant.available !==
            false
          );
        }
      ) ||
      product.variants[0] ||
      null
    );
  }

  function variantById(
    product,
    variantId
  ) {
    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {
      return null;
    }

    var id =
      numericId(variantId);

    return (
      product.variants.find(
        function (variant) {
          return (
            String(variant.id) ===
            String(id)
          );
        }
      ) || null
    );
  }

  function resolveVariant(
    handle,
    preferredId
  ) {
    return fetchProduct(handle)
      .then(function (product) {
        return {
          product: product,
          variant:
            variantById(
              product,
              preferredId
            ) ||
            firstAvailableVariant(
              product
            )
        };
      });
  }

 function updateButtons() {
  var wishlistHasItems =
    state.items.length > 0;

  /*
   * Update every product-level wishlist button.
   */
  document
    .querySelectorAll(
      [
        '.wishlist-toggle[data-product-handle]',
        '.cw-cart-wishlist[data-product-handle]'
      ].join(', ')
    )
    .forEach(function (button) {
      var active =
        Boolean(
          findItem(
            button.getAttribute(
              'data-product-handle'
            )
          )
        );

      button.classList.toggle(
        'is-active',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active
          ? 'true'
          : 'false'
      );

      var label =
        button.getAttribute(
          'aria-label'
        ) || '';

      if (label) {
        var productLabel = label
          .replace(/^Add\s+/i, '')
          .replace(/^Remove\s+/i, '')
          .replace(/\s+to wishlist$/i, '')
          .replace(/\s+from wishlist$/i, '');

        button.setAttribute(
          'aria-label',
          active
            ? 'Remove ' + productLabel + ' from wishlist'
            : 'Add ' + productLabel + ' to wishlist'
        );
      }
    });

  /*
   * Update every general wishlist icon, including the
   * desktop header, mobile menu and drawer wishlist tab.
   */
  document
    .querySelectorAll(
      [
        '[data-wishlist-open]',
        '[data-wishlist-link]',
        '[data-aa-mobile-wishlist]',
        '[data-cw-tab="wishlist"]'
      ].join(', ')
    )
    .forEach(function (button) {
      var indicator =
        button.querySelector(
          '[data-aa-wishlist-indicator]'
        );

      button.classList.toggle(
        'has-wishlist-items',
        wishlistHasItems
      );

      if (
        button.matches(
          '[data-wishlist-open], [data-wishlist-link], [data-aa-mobile-wishlist]'
        )
      ) {
        button.setAttribute(
          'aria-label',
          wishlistHasItems
            ? 'Open wishlist, wishlist contains items'
            : 'Open wishlist'
        );
      }

      if (indicator) {
        indicator.hidden =
          !wishlistHasItems;

        indicator.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    });
}

function observeWishlistButtons() {
  if (
    !window.MutationObserver ||
    !document.documentElement
  ) {
    return;
  }

  var observer = new MutationObserver(
    function (mutations) {
      var shouldSync = mutations.some(
        function (mutation) {
          return Array.prototype.some.call(
            mutation.addedNodes,
            function (node) {
              if (
                !node ||
                node.nodeType !== 1
              ) {
                return false;
              }

              if (
                node.matches &&
                node.matches(
                  '.wishlist-toggle[data-product-handle], .cw-cart-wishlist[data-product-handle], [data-wishlist-open], [data-wishlist-link], [data-aa-mobile-wishlist], [data-cw-tab="wishlist"]'
                )
              ) {
                return true;
              }

              return Boolean(
                node.querySelector &&
                node.querySelector(
                  '.wishlist-toggle[data-product-handle], .cw-cart-wishlist[data-product-handle], [data-wishlist-open], [data-wishlist-link], [data-aa-mobile-wishlist], [data-cw-tab="wishlist"]'
                )
              );
            }
          );
        }
      );

      if (!shouldSync) return;

      window.clearTimeout(
        state.observerTimer
      );

      state.observerTimer =
        window.setTimeout(
          updateButtons,
          0
        );
    }
  );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
}

  function showWishlistState(name) {
    var drawer = getDrawer();

    if (!drawer) return;

    var selectors = {
      loading:
        '[data-cw-wishlist-loading]',

      guest:
        '[data-cw-wishlist-guest]',

      empty:
        '[data-cw-wishlist-empty]',

      list:
        '[data-cw-wishlist-list]'
    };

    Object.keys(
      selectors
    ).forEach(function (key) {
      var element =
        drawer.querySelector(
          selectors[key]
        );

      if (!element) return;

      if (key === name) {
        element.removeAttribute(
          'hidden'
        );
      } else {
        element.setAttribute(
          'hidden',
          ''
        );
      }
    });
  }

  function optionIndex(
    product,
    candidates
  ) {
    return (
      product.options || []
    ).findIndex(function (name) {
      var normalized =
        String(name || '')
          .toLowerCase();

      return candidates.some(
        function (candidate) {
          return (
            normalized.indexOf(
              candidate
            ) !== -1
          );
        }
      );
    });
  }

  function cleanLabel(product) {
    var tags =
      Array.isArray(product.tags)
        ? product.tags
        : [];

    var newTag =
      tags.some(function (tag) {
        var normalized =
          String(tag || '')
            .toLowerCase()
            .replace(
              /[-_/]+/g,
              ' '
            )
            .trim();

        return (
          normalized === 'new' ||
          normalized ===
            'new arrival' ||
          normalized ===
            'new arrivals'
        );
      });

    if (newTag) return 'NEW';

    return String(
      tags[0] || ''
    )
      .replace(
        /[-_/]+/g,
        ' '
      )
      .trim();
  }

  function imageUrl(image) {
    if (!image) return '';

    if (
      typeof image ===
      'string'
    ) {
      return image;
    }

    return (
      image.src ||
      image.url ||
      ''
    );
  }

  function createIcon(name) {
    if (name === 'bag') {
      return [
        `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1080 1080"
  width="24"
  height="24"
  aria-hidden="true"
  focusable="false"
>
  <g
    transform="translate(0 1080) scale(0.1 -0.1)"
    fill="currentColor"
    stroke="none"
  >
    <path d="M5625 9004 c-71 -8 -152 -21 -180 -29 -27 -8 -66 -18 -85 -21 -34 -6
    -167 -48 -199 -63 -183 -86 -256 -130 -374 -223 -186 -148 -296 -284 -421
    -523 -42 -79 -70 -152 -92 -239 -8 -33 -18 -65 -23 -70 -5 -6 -14 -47 -20 -91
    -8 -58 -17 -85 -31 -97 -18 -15 -80 -17 -638 -21 -521 -4 -625 -7 -669 -20
    -65 -20 -106 -49 -146 -107 l-32 -45 0 -2770 0 -2770 26 -44 c33 -54 97 -97
    169 -113 80 -19 5637 -19 5724 -1 82 18 137 55 170 117 l27 51 -3 2770 -3
    2770 -23 42 c-27 49 -73 80 -152 105 -50 16 -114 18 -667 18 -594 0 -614 1
    -632 19 -11 11 -22 35 -25 53 -20 144 -31 196 -62 288 -47 137 -118 271 -220
    416 -85 120 -292 297 -464 396 -120 69 -298 148 -333 148 -10 0 -43 9 -75 19
    -33 11 -115 24 -192 30 -74 6 -155 13 -180 15 -25 2 -103 -2 -175 -10z

    m409 -519
    c16 -9 48 -18 70 -22 23 -3 57 -14 76 -25 19 -10 41 -18 48 -18 20 0 173
    -90 207 -122 17 -15 34 -28 38 -28 33 0 249 -252 263 -304 3 -14 12 -30 20
    -37 8 -6 14 -18 14 -26 0 -8 11 -38 24 -66 14 -29 27 -82 31 -118 6 -58 5 -67
    -11 -73 -58 -22 -2003 -27 -2061 -5 -30 11 -31 55 -3 109 11 22 20 48 20 58 0
    25 64 161 102 216 95 137 220 251 375 341 35 20 65 41 69 46 3 5 15 9 27 9 12
    0 36 9 52 20 17 11 40 20 53 20 12 0 39 8 60 17 54 24 146 32 332 27 118 -3
    173 -9 194 -19z"/>
  </g>
</svg>`
      ].join('');
    }

    if (name === 'trash') {
      return [
        '<svg viewBox="0 0 24 24" aria-hidden="true">',
        '<path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v6m4-6v6" fill="none" stroke="currentColor" stroke-width="1.7"/>',
        '</svg>'
      ].join('');
    }

    return '';
  }

  function createWishlistItem(
  item,
  product
) {
  var selected =
    variantById(
      product,
      item.variantId
    ) ||
    firstAvailableVariant(
      product
    );

  if (!selected) return null;

var productOptions =
  Array.isArray(
    product.options
  )
    ? product.options
    : [];

var colorIndex =
  optionIndex(
    product,
    [
      'color',
      'colour'
    ]
  );

var sizeIndex =
  optionIndex(
    product,
    [
      'size'
    ]
  );

/*
 * Fallback:
 * If the product does not have an option literally named Size,
 * use the first option that is not Color.
 */
if (sizeIndex < 0) {
  sizeIndex =
    productOptions.findIndex(
      function (
        optionName,
        index
      ) {
        return (
          index !== colorIndex
        );
      }
    );
}

var selectedOptions =
  getVariantOptions(
    selected
  );

var selectedColor =
  colorIndex > -1
    ? selectedOptions[
        colorIndex
      ] || ''
    : '';

/*
 * Preserve Color, Length, Inseam, and every other selected option.
 * Only Size is allowed to change in this dropdown.
 */
var matchingVariants =
  (
    product.variants || []
  ).filter(
    function (variant) {
      var options =
        getVariantOptions(
          variant
        );

      return selectedOptions.every(
        function (
          selectedValue,
          index
        ) {
          if (
            index === sizeIndex
          ) {
            return true;
          }

          return (
            options[index] ===
            selectedValue
          );
        }
      );
    }
  );

var choices =
  new Map();

matchingVariants.forEach(
  function (variant) {
    var variantOptions =
      getVariantOptions(
        variant
      );

    var choiceLabel =
      sizeIndex > -1
        ? variantOptions[
            sizeIndex
          ]
        : '';

    if (
      !choiceLabel ||
      choiceLabel ===
        'Default Title'
    ) {
      choiceLabel =
        'Option';
    }

    var existingChoice =
      choices.get(
        choiceLabel
      );

    if (
      !existingChoice ||
      String(variant.id) ===
        String(selected.id)
    ) {
      choices.set(
        choiceLabel,
        variant
      );
    }
  }
);

if (!choices.size) {
  choices.set(
    sizeIndex > -1
      ? selectedOptions[
          sizeIndex
        ] || 'Option'
      : 'Option',
    selected
  );
}

  var article =
    document.createElement(
      'article'
    );

  article.className =
    'cw-wishlist-item';

  article.setAttribute(
    'data-wishlist-product-handle',
    product.handle
  );

  article.setAttribute(
    'data-current-variant-id',
    String(selected.id)
  );

  var productImage =
    imageUrl(
      selected.featured_image ||
      selected.image ||
      product.featured_image
    );

  var label =
    cleanLabel(product);

  var metadata =
    [
      selectedColor,
      product.type
    ]
      .filter(Boolean)
      .join(' - ');

  var options = '';

  choices.forEach(
    function (
      variant,
      choiceLabel
    ) {
      var selectedAttribute =
        String(variant.id) ===
        String(selected.id)
          ? ' selected'
          : '';

      var disabledAttribute =
        variant.available ===
          false
          ? ' disabled'
          : '';

      var soldOutText =
        variant.available ===
          false
          ? ' — Out of stock'
          : '';

      options +=
        '<option value="' +
        escapeHtml(variant.id) +
        '"' +
        selectedAttribute +
        disabledAttribute +
        '>' +
        escapeHtml(choiceLabel) +
        soldOutText +
        '</option>';
    }
  );

  article.innerHTML =
    '<a class="cw-wishlist-item__image" href="' +
    productUrl(product.handle) +
    '">' +

    (
      productImage
        ? '<img src="' +
          escapeHtml(productImage) +
          '" alt="' +
          escapeHtml(
            product.title || ''
          ) +
          '" loading="lazy">'
        : ''
    ) +

    '</a>' +

    '<div class="cw-wishlist-item__info">' +

    (
      label
        ? '<span class="cw-product-label">' +
          escapeHtml(label) +
          '</span>'
        : ''
    ) +

    '<a class="cw-wishlist-item__title" href="' +
    productUrl(product.handle) +
    '">' +
    escapeHtml(
      product.title || ''
    ) +
    '</a>' +

    '<div class="cw-wishlist-item__meta">' +
    escapeHtml(metadata) +
    '</div>' +

    '<div class="cw-wishlist-item__price" data-cw-wishlist-price>' +
    money(selected.price) +
    '</div>' +

    '</div>' +

    '<button class="cw-menu-button" type="button" aria-label="More options" aria-expanded="false" data-cw-menu-toggle>•••</button>' +

    '<label class="cw-wishlist-selector">' +
    '<span class="visually-hidden">Select option</span>' +
    '<select data-cw-variant-select data-product-handle="' +
    escapeHtml(product.handle) +
    '">' +
    options +
    '</select>' +
    '</label>' +

    '<button class="cw-icon-button cw-wishlist-bag" type="button" data-cw-add-variant="' +
    escapeHtml(selected.id) +
    '" aria-label="Add to bag"' +

    (
      selected.available ===
        false
        ? ' disabled'
        : ''
    ) +

    '>' +
    createIcon('bag') +
    '</button>' +

    '<div class="cw-wishlist-menu" hidden data-cw-menu>' +

    '<button type="button" data-cw-menu-add>' +
    createIcon('bag') +
    '<span>Add to bag</span>' +
    '</button>' +

    '<button type="button" class="is-danger" data-cw-remove-wishlist data-product-handle="' +
    escapeHtml(product.handle) +
    '">' +
    createIcon('trash') +
    '<span>Remove from wishlist</span>' +
    '</button>' +

    '</div>';

  return article;
}

  function renderWishlist() {
  var drawer = getDrawer();

  if (!drawer) return;

  if (state.rendering) {
    state.renderQueued = true;
    return;
  }

  if (!state.items.length) {
    showWishlistState(
      'empty'
    );

    return;
  }

  var list =
    drawer.querySelector(
      '[data-cw-wishlist-list]'
    );

  if (!list) return;

  state.rendering = true;

  showWishlistState(
    'loading'
  );

  Promise.all(
    state.items.map(
      function (item) {
        return fetchProduct(
          item.handle
        ).catch(
          function () {
            return null;
          }
        );
      }
    )
  )
    .then(
      function (products) {
        list.innerHTML = '';

        products.forEach(
          function (
            product,
            index
          ) {
            if (!product) return;

            var node =
              createWishlistItem(
                state.items[index],
                product
              );

            if (node) {
              list.appendChild(
                node
              );
            }
          }
        );

        showWishlistState(
          list.children.length
            ? 'list'
            : 'empty'
        );
      }
    )
    .catch(
      function (error) {
        console.error(
          '[cart-wishlist] Wishlist rendering failed.',
          error
        );

        showWishlistState(
          'empty'
        );
      }
    )
    .finally(
      function () {
        state.rendering = false;

        if (
          state.renderQueued
        ) {
          state.renderQueued =
            false;

          renderWishlist();
        }
      }
    );
}

function toggleWishlist(
  button
) {
  var handle =
    button.getAttribute(
      'data-product-handle'
    );

  if (!handle) {
    return Promise.resolve();
  }

  var existing =
    findItem(handle);

  if (existing) {
    removeWishlist(handle);

    return Promise.resolve();
  }

  button.setAttribute(
    'aria-busy',
    'true'
  );

  return resolveVariant(
    handle,
    getSelectedVariantId(
      button
    )
  )
    .then(
      function (resolved) {
        if (!resolved.variant) {
          return;
        }

        state.items.push({
          handle: handle,
          variantId:
            String(
              resolved.variant.id
            )
        });

        writeItems();
        updateButtons();

        if (
          state.activeView ===
          'wishlist'
        ) {
          renderWishlist();
        }

        showWishlistToast(
          'Item added to your wishlist',
          'View',
          goToWishlistPage
        );
      }
    )
    .catch(
      function (error) {
        console.error(
          '[cart-wishlist] Could not add wishlist item.',
          error
        );
      }
    )
    .finally(
      function () {
        button.removeAttribute(
          'aria-busy'
        );
      }
    );
}

function removeWishlist(
  handle
) {
  var removedIndex =
    state.items.findIndex(
      function (item) {
        return (
          item.handle ===
          handle
        );
      }
    );

  if (removedIndex < 0) {
    return;
  }

  var removedItem =
    Object.assign(
      {},
      state.items[
        removedIndex
      ]
    );

  state.items.splice(
    removedIndex,
    1
  );

  writeItems();
  updateButtons();

  if (
    state.activeView ===
    'wishlist'
  ) {
    renderWishlist();
  }

  showWishlistToast(
    'Item removed from the wishlist',
    'Undo',
    function () {
      if (
        findItem(
          removedItem.handle
        )
      ) {
        return;
      }

      state.items.splice(
        Math.min(
          removedIndex,
          state.items.length
        ),
        0,
        removedItem
      );

writeItems('undo');
updateButtons();

/*
 * Render the drawer wishlist even when its tab is hidden.
 * This ensures it is already updated when opened later.
 */
renderWishlist();
    }
  );
}

 function changeVariant(
  select
) {
  var handle =
    select.getAttribute(
      'data-product-handle'
    );

  var item =
    findItem(handle);

  if (!item) return;

  item.variantId =
    String(select.value);

  writeItems();

  var article =
    select.closest(
      '.cw-wishlist-item'
    );

  if (!article) return;

  fetchProduct(handle)
    .then(
      function (product) {
        var variant =
          variantById(
            product,
            select.value
          );

        if (!variant) return;

        article.setAttribute(
          'data-current-variant-id',
          String(variant.id)
        );

        var price =
          article.querySelector(
            '[data-cw-wishlist-price]'
          );

        if (price) {
          price.textContent =
            money(
              variant.price
            );
        }

        var image =
          article.querySelector(
            '.cw-wishlist-item__image img'
          );

        var nextImage =
          imageUrl(
            variant.featured_image ||
            variant.image ||
            product.featured_image
          );

        if (
          image &&
          nextImage
        ) {
          image.src =
            nextImage;
        }

        var bag =
          article.querySelector(
            '[data-cw-add-variant]'
          );

        if (bag) {
          bag.setAttribute(
            'data-cw-add-variant',
            String(variant.id)
          );

          bag.disabled =
            variant.available ===
            false;
        }
      }
    )
    .catch(
      function (error) {
        console.error(
          '[cart-wishlist] Could not change wishlist option.',
          error
        );
      }
    );
}

  function hydrateCartSection(
    sectionHtml
  ) {
    if (!sectionHtml) {
      return false;
    }

    var parsed =
      new DOMParser()
        .parseFromString(
          sectionHtml,
          'text/html'
        );

    var nextInner =
      parsed.querySelector(
        '#cart-drawer [data-hydration-key="cart-drawer-inner"]'
      ) ||
      parsed.querySelector(
        '[data-hydration-key="cart-drawer-inner"]'
      );

    var currentInner =
      document.querySelector(
        '#cart-drawer [data-hydration-key="cart-drawer-inner"]'
      );

    if (
      !nextInner ||
      !currentInner
    ) {
      return false;
    }

    var imported =
      document.importNode(
        nextInner,
        true
      );

    currentInner.replaceWith(
      imported
    );

    if (
      window.customElements &&
      typeof window.customElements.upgrade ===
        'function'
    ) {
      window.customElements.upgrade(
        imported
      );
    }

    updateButtons();
    activate('cart');

    return true;
  }

  function fetchCartSection() {
    var url =
      rootUrl() +
      '?section_id=cart-drawer-section';

    return fetch(
      url,
      {
        credentials:
          'same-origin'
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not refresh cart drawer.'
          );
        }

        return response.text();
      })
      .then(
        hydrateCartSection
      );
  }

  function updateCartIcons(
    itemCount
  ) {
    document
      .querySelectorAll(
        'cart-icon'
      )
      .forEach(function (icon) {
        if (
          typeof icon.renderCartBubble ===
          'function'
        ) {
          icon.renderCartBubble(
            Number(
              itemCount || 0
            )
          );
        }
      });
  }

  function addVariantToCart(
    variantId,
    sourceButton
  ) {
    if (!variantId) {
      return Promise.resolve();
    }

    if (sourceButton) {
      sourceButton.setAttribute(
        'aria-busy',
        'true'
      );
    }

    return fetch(
      rootUrl() + 'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        credentials:
          'same-origin',

        body: JSON.stringify({
          items: [
            {
              id: Number(
                numericId(
                  variantId
                )
              ),

              quantity: 1
            }
          ],

          sections: [
            'cart-drawer-section'
          ],

          sections_url:
            window.location.pathname
        })
      }
    )
      .then(function (response) {
        return response
          .json()
          .then(function (payload) {
            if (!response.ok) {
              throw new Error(
                payload.description ||
                'Unable to add this product.'
              );
            }

            return payload;
          });
      })
      .then(function (payload) {
        var sectionHtml =
          payload.sections &&
          payload.sections[
            'cart-drawer-section'
          ];

        var hydrated =
          hydrateCartSection(
            sectionHtml
          );

        return hydrated
          ? true
          : fetchCartSection();
      })
      .then(function () {
        return fetch(
          rootUrl() + 'cart.js',
          {
            headers: {
              Accept:
                'application/json'
            },

            credentials:
              'same-origin'
          }
        );
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not refresh cart count.'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        updateCartIcons(
          cart.item_count
        );

        document.dispatchEvent(
          new CustomEvent(
            'cart:updated',
            {
              detail: {
                source:
                  'cart-wishlist-drawer',

                cart: cart
              }
            }
          )
        );

        openDrawer('cart');
      })
      .catch(function (error) {
        console.error(
          '[cart-wishlist] Add to cart failed.',
          error
        );
      })
      .finally(function () {
        if (sourceButton) {
          sourceButton.removeAttribute(
            'aria-busy'
          );
        }
      });
  }

  function closeMenus(except) {
    document
      .querySelectorAll(
        '[data-cw-menu]'
      )
      .forEach(function (menu) {
        if (
          menu !== except
        ) {
          menu.hidden = true;
        }
      });

    document
      .querySelectorAll(
        '[data-cw-menu-toggle]'
      )
      .forEach(function (button) {
        var ownMenu =
          button.closest(
            '.cw-wishlist-item'
          );

        ownMenu =
          ownMenu
            ? ownMenu.querySelector(
                '[data-cw-menu]'
              )
            : null;

        if (
          !except ||
          ownMenu !== except
        ) {
          button.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      });
  }

  function closeDeliveryPopovers(
    except
  ) {
    document
      .querySelectorAll(
        '[data-cw-delivery-popover]'
      )
      .forEach(
        function (popover) {
          if (
            popover === except
          ) {
            return;
          }

          popover.hidden = true;

          var button =
            popover.parentElement
              ? popover.parentElement.querySelector(
                  '[data-cw-delivery-toggle]'
                )
              : null;

          if (button) {
            button.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        }
      );
  }

  function bindEvents() {
  document.addEventListener(
    'click',
    function (event) {
      var backdrop =
        eventClosest(
          event,
          '[data-cw-drawer-backdrop]'
        );

      if (backdrop) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var tab =
        eventClosest(
          event,
          '[data-cw-tab]'
        );

      if (tab) {
        event.preventDefault();

        activate(
          tab.getAttribute(
            'data-cw-tab'
          )
        );

        return;
      }

      var wishlistOpen =
        eventClosest(
          event,
          '[data-wishlist-open]'
        );

      if (wishlistOpen) {
        event.preventDefault();

        openDrawer(
          'wishlist'
        );

        return;
      }

      var menuToggle =
        eventClosest(
          event,
          '[data-cw-menu-toggle]'
        );

      if (menuToggle) {
        event.preventDefault();
        event.stopPropagation();

        var menuItem =
          menuToggle.closest(
            '.cw-wishlist-item'
          );

        var menu =
          menuItem
            ? menuItem.querySelector(
                '[data-cw-menu]'
              )
            : null;

        if (!menu) return;

        var shouldOpen =
          menu.hidden;

        closeMenus(menu);

        menu.hidden =
          !shouldOpen;

        menuToggle.setAttribute(
          'aria-expanded',
          shouldOpen
            ? 'true'
            : 'false'
        );

        return;
      }

      var menuAdd =
        eventClosest(
          event,
          '[data-cw-menu-add]'
        );

      if (menuAdd) {
        event.preventDefault();
        event.stopPropagation();

        var article =
          menuAdd.closest(
            '.cw-wishlist-item'
          );

        var bagButton =
          article
            ? article.querySelector(
                '[data-cw-add-variant]'
              )
            : null;

        if (bagButton) {
          addVariantToCart(
            bagButton.getAttribute(
              'data-cw-add-variant'
            ),
            menuAdd
          );
        }

        closeMenus();
        return;
      }

      var remove =
        eventClosest(
          event,
          '[data-cw-remove-wishlist]'
        );

      if (remove) {
        event.preventDefault();
        event.stopPropagation();

        removeWishlist(
          remove.getAttribute(
            'data-product-handle'
          )
        );

        closeMenus();
        return;
      }

      var addButton =
        eventClosest(
          event,
          '[data-cw-add-variant]'
        );

      if (addButton) {
        event.preventDefault();
        event.stopPropagation();

        addVariantToCart(
          addButton.getAttribute(
            'data-cw-add-variant'
          ),
          addButton
        );

        return;
      }

      var wishlistButton =
        eventClosest(
          event,
          '.wishlist-toggle[data-product-handle], .cw-cart-wishlist[data-product-handle]'
        );

      if (wishlistButton) {
        event.preventDefault();
        event.stopPropagation();

        toggleWishlist(
          wishlistButton
        );

        return;
      }

      var info =
        eventClosest(
          event,
          '[data-cw-delivery-toggle]'
        );

if (info) {
  event.preventDefault();

  /*
   * Desktop uses CSS hover/focus.
   * Touch devices continue using click/tap.
   */
  if (
    window.matchMedia &&
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches
  ) {
    return;
  }

  var popover =
          info.parentElement
            ? info.parentElement
                .querySelector(
                  '[data-cw-delivery-popover]'
                )
            : null;

        if (popover) {
          var shouldShow =
            popover.hidden;

          closeDeliveryPopovers(
            popover
          );

          popover.hidden =
            !shouldShow;

          info.setAttribute(
            'aria-expanded',
            shouldShow
              ? 'true'
              : 'false'
          );
        }

        return;
      }

      var cartOpen =
        eventClosest(
          event,
          '[data-cw-open-cart]'
        );

      if (cartOpen) {
        activate('cart');
      }

      if (
        !eventClosest(
          event,
          '[data-cw-menu], [data-cw-menu-toggle]'
        )
      ) {
        closeMenus();
      }

      if (
        !eventClosest(
          event,
          '.cw-info-wrap'
        )
      ) {
        closeDeliveryPopovers();
      }
    }
  );

  document.addEventListener(
    'change',
    function (event) {
      var select =
        eventClosest(
          event,
          '[data-cw-variant-select]'
        );

      if (select) {
        changeVariant(
          select
        );
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !==
        'Escape'
      ) {
        return;
      }

      closeMenus();
      closeDeliveryPopovers();
    }
  );

  document.addEventListener(
    'theme-drawer:open',
    function (event) {
      var drawer =
        eventClosest(
          event,
          'theme-drawer'
        );

      if (
        drawer &&
        drawer.id ===
          'cart-drawer'
      ) {
        setDrawerScrollLock(
          true
        );
      }
    }
  );

  document.addEventListener(
    'theme-drawer:close',
    function (event) {
      var drawer =
        eventClosest(
          event,
          'theme-drawer'
        );

      if (
        drawer &&
        drawer.id ===
          'cart-drawer'
      ) {
        setDrawerScrollLock(
          false
        );
      }
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      updateButtons();

      activate(
        state.activeView
      );
    }
  );
}

  function init() {
  bindEvents();
  observeWishlistButtons();
  updateButtons();
  activate('cart');

    var drawer = getDrawer();

    if (
      drawer &&
      drawer.hasAttribute(
        'open'
      )
    ) {
      setDrawerScrollLock(
        true
      );
    }
  }

  window.CartWishlistDrawer = {
    activate: activate,

    showCart:
      function () {
        activate('cart');
      },

    showWishlist:
      function () {
        openDrawer(
          'wishlist'
        );
      },

    renderWishlist:
      renderWishlist,
    createIcon:
  createIcon,
    addVariantToCart:
      addVariantToCart,

    getItems:
      function () {
        return state.items.map(
          function (item) {
            return {
              handle: item.handle,
              variantId: item.variantId
            };
          }
        );
      },

    removeItem:
      function (handle) {
        removeWishlist(
          String(handle || '')
        );
      },

    setItemVariant:
      function (
        handle,
        variantId
      ) {
        var item = findItem(
          String(handle || '')
        );

        if (!item || !variantId) {
          return false;
        }

        item.variantId = String(
          numericId(variantId)
        );

        writeItems('variant');
        updateButtons();

        if (
          state.activeView ===
          'wishlist'
        ) {
          renderWishlist();
        }

        return true;
      },

    refreshFromStorage:
      function () {
        state.items = readItems();
        updateButtons();

        if (
          state.activeView ===
          'wishlist'
        ) {
          renderWishlist();
        }

        return state.items.length;
      }
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();